import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  AdsBanner: css`
    font: revert;
  `,
}
